import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'

/** Upload controls backed by the active knowledge-base workspace selection. */
@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.input.file.Component,
    ds.layout.widget.Component,
  ],
  selector: 'atn-admin-knowledge-bases-page-document-upload',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** File extensions accepted by the knowledge-base ingestion pipeline. */
  public readonly supportedFileExtensions = Array.from(
    ents.core.agent.KnowledgeBase.Management.SUPPORTED_FILE_EXTENSIONS,
  )

  /** Maximum supported upload size displayed to Platform Admin users. */
  public readonly maximumFileSizeLabel = `${
    ents.core.agent.KnowledgeBase.Management.MAXIMUM_FILE_SIZE_BYTES /
    (1024 * 1024)
  } MB`

  /** Route-bound collection containing the canonical upload state. */
  public readonly filesEc = ngCore.inject(
    state.admin.agentKnowledgeBases.Collection,
  )
}
